import React from "react";

const Board = (props) => {
  return <div className="board" {...props}></div>;
};

export default Board;
